import axios from 'axios';

export const getOnceCaptcha = () => axios.get('api/login_captcha', {});

export const getPhoneNumber = uorp =>
  axios.get('api/uandp', {
    params: { uorp }
  });

export const getSmsCaptcha = phone =>
  axios.get('api/sms/login_pcaptcha', {
    params: { phone }
  });

export const getCodeCaptcha = (phone, code) =>
  axios.get(' api/login_captcha_image_need_code', {
    params: { phone, code },
    responseType: 'blob'
  });
